import React from 'react';
import {RequiredAstrix} from "./FormElements";
import PropTypes from 'prop-types';
import Select from 'react-select';
import {Field} from "formik";

const SelectField = (props) => {
    const {
        id,
        label,
        required,
        name,
        onChange,
        options,
        extraClass,
        selectClass,
    } = props;

    const setValue = (options, value) => options.find(option => option.value === value);

    return (
        <div className={`form-group ${extraClass}`}>
            <label htmlFor={id}>{label} {required && <RequiredAstrix/>}</label>
            <Field name={name}>
                {({form, field}) => {
                    const showValidation = (!form.isSubmitting) && (form.touched[field.name] || form.submitCount > 0);

                    return (
                        <>
                            <Select
                                className={`mb-1 ${selectClass}`}
                                classNamePrefix="select"
                                isSearchable={false}
                                name={name}
                                onChange={onChange}
                                placeholder={'Select one'}
                                value={options ? setValue(options, field.value) : ''}
                                options={options}
                                onBlur={field.onBlur}
                                valid={Boolean(showValidation && !form.errors[field.name])}
                                invalid={Boolean(showValidation && form.errors[field.name])}
                                onMenuOpen={() => form.setFieldTouched(field.name, true)}
                            />
                            {showValidation && form.errors[field.name] &&
                            <div className={'invalid'}>{form.errors[field.name]}</div>}
                        </>
                    )
                }}
            </Field>
        </div>
    )
}

SelectField.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array,
    extraClass: PropTypes.string,
    selectClass: PropTypes.string
}

SelectField.defaultProps = {
    extraClass: '',
    selectClass: '',
    required: false
}

export default SelectField;
